import { createReducer } from 'Utils/reducer-generator';
import { actionNavOpened } from '../actions/nav-opened-ac';

export default createReducer(actionNavOpened, false);



// WEBPACK FOOTER //
// src/base/reducers/nav-open-rd.js